import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from 'firebase/auth';

// Your Firebase configuration
// You'll need to replace these with your actual Firebase config values
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "your-api-key",
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
//   appId: process.env.REACT_APP_FIREBASE_APP_ID || "your-app-id"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCkycRVMmiPyl5ZD8es1x-zHQkrXDBMx2k",
  authDomain: "occasia-platform.firebaseapp.com",
  projectId: "occasia-platform",
  storageBucket: "occasia-platform.firebasestorage.app",
  messagingSenderId: "939097408765",
  appId: "1:939097408765:web:c0daa4c858b0145d62aa94",
  measurementId: "G-ZW1DXV35ZD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize providers
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();

// Configure Google provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Configure Facebook provider
facebookProvider.setCustomParameters({
  display: 'popup'
});

export default app;
